import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoCard.module.css";
import Button from "shared/Button";
import Card from "shared/Card";
import classNames from "classnames";

/**
 * Interactive component. Used on users, groups and home pages.
 * Displays info and opens a modal when the btn is clicked.
 */
export function InfoCard({ header, body, footer, btnName, onClick }) {
  return (
    <Card className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <div className={styles.header}>{header}</div>
        <div className={styles.body}>{body}</div>
        <div className={styles.footer}>{footer}</div>
        {btnName && (
        <Button
          className={classNames(styles.button, {
            [styles.noBodyButton]: body === "",
          })}
          onClick={onClick}
          size="small"
        >
          {btnName}
        </Button>)}
      </div>
    </Card>
  );
}

InfoCard.propTypes = {
  /**
   * Header at the top of the card
   */
  header: PropTypes.string,
  /**
   * Yellow text in the center of the card
   */
  body: PropTypes.string,
  /**
   * 	Italicized text at the bottom of the card
   */
  footer: PropTypes.string,
  /**
   * 	Btns text
   */
  btnName: PropTypes.string,
  /**
   * 	Function called when the btn is clicked (opens different modals)
   */
  onClick: PropTypes.func,
};
